module.exports = __webpack_public_path__ + "img/trainers-svg-desktop.facfbe70.svg";